/** Small compatibility layer for the installed app. Its own close control owns cleanup. */
export function isBackdropClick(target, modal) {
  return Boolean(modal && target?.closest?.('.instagenie-modal') === modal &&
    !target.closest('.instagenie-modal-insta'));
}

export function closeInstagramModal(modal, opener) {
  const close = modal?.querySelector('.instagenie-header .close-button');
  if (!close) return false;
  // Use the vendor handler: it pauses video and removes the app's open state.
  close.click();
  if (!modal.classList.contains('instagenie-modal-show') && opener?.isConnected) {
    if (!opener.hasAttribute('tabindex')) opener.setAttribute('tabindex', '-1');
    opener.focus({preventScroll: true});
  }
  return !modal.classList.contains('instagenie-modal-show');
}

export function installInstagramDismissal(root) {
  let pressedBackdrop = null;
  let opener = null;
  const controller = new AbortController();
  const options = {capture: true, signal: controller.signal};

  root.addEventListener('pointerdown', event => {
    const modal = event.target?.closest?.('.instagenie-modal-show');
    pressedBackdrop = isBackdropClick(event.target, modal) ? modal : null;
  }, options);

  root.addEventListener('click', event => {
    const trigger = event.target?.closest?.('.instagenie-grid, .instagenie-stories-grid');
    if (trigger) opener = trigger;
    const modal = event.target?.closest?.('.instagenie-modal-show');
    if (pressedBackdrop === modal && isBackdropClick(event.target, modal)) {
      event.preventDefault();
      event.stopPropagation();
      closeInstagramModal(modal, opener);
    }
    pressedBackdrop = null;
  }, options);

  root.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || event.isComposing) return;
    const modals = root.querySelectorAll('.instagenie-modal-show');
    const modal = modals[modals.length - 1];
    if (!modal) return;
    if (closeInstagramModal(modal, opener)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, options);

  return () => controller.abort();
}

if (typeof document !== 'undefined') installInstagramDismissal(document);
